<template>
	<!-- 🔥 完全隐藏AGENT_TASK_STATUS消息（只作为数据源，不显示UI） -->
	<div v-if="!isAgentTaskStatusMessage" class="chat-msg-item" :class="{ 'multi-select-mode': isMultiSelectMode, 'selected': isSelected }">
		<div class="chat-msg-tip" v-if="msgInfo.type == $enums.MESSAGE_TYPE.TIP_TIME">
			{{ $date.toTimeText(msgInfo.sendTime) }}
		</div>
		<div class="chat-msg-normal"
			v-else-if="isNormal || msgInfo.type == $enums.MESSAGE_TYPE.TIP_TEXT"
			:class="{ 'chat-msg-mine': mine, 'selectable': isMultiSelectMode }"
			@click="handleMessageClick">
			<!-- 🔥 多选模式复选框 -->
			<MessageCheckbox
				v-if="isMultiSelectMode"
				:messageId="msgInfo.id || msgInfo.tmpId"
				:selected="isSelected"
				position="left"
				@toggle="toggleSelection"
			/>
			<div class="head-image" v-if="!isTipMessage">
				<head-image :name="showName" :size="38" :url="headImage" :id="parseInt(msgInfo.sendId) || 0"></head-image>
			</div>
			<div class="chat-msg-content">
				<div v-show="mode == 1 && msgInfo.groupId && !msgInfo.selfSend && !isTipMessage" class="chat-msg-top">
					<span>{{ showName }}</span>
				</div>
				<div v-show="mode == 2 && !isTipMessage" class="chat-msg-top">
					<span>{{ showName }}</span>
					<span>{{ $date.toTimeText(msgInfo.sendTime) }}</span>
				</div>
				<!-- 🔥 在消息内容容器上添加右键菜单激活高亮 -->
				<div class="chat-msg-bottom"
					:class="{ 'context-menu-active': rightMenu.show }"
					@contextmenu="handleContextMenu($event)">
					<div ref="chatMsgBox">
						<!-- 如果是加载中状态，显示加载动效 -->
						<div class="chat-msg-text" v-if="msgInfo.isLoading">
							<loading-dots />
						</div>
					<!-- 🔥 RooCode Agent 结构化消息 -->
					<div
						class="chat-msg-text structured-message-card"
						v-else-if="msgInfo._isStructured && ((msgInfo._structuredChunks && msgInfo._structuredChunks.length > 0) || msgInfo._finalContent)"
					>
						<div class="structured-card-header">
							<div class="structured-card-title">
								<span class="name">{{ showName }}</span>
						<span v-if="msgInfo.agentMode" class="mode-tag">{{ msgInfo.agentMode }}</span>
					</div>
					<span class="time">{{ messageTimeText }}</span>
					</div>
					<roo-code-task-message
						ref="structuredTaskMessage"
						:structured-chunks="msgInfo._structuredChunks || []"
						:msg-info="msgInfo"
						:stream-id="msgInfo.streamId || msgInfo.tmpId"
						@task-completed="onTaskCompleted"
						@open-terminal="handleOpenTerminal"
						@abort-command="handleAbortCommand"
					/>
				</div>
						<!-- 智能体消息使用统一Markdown渲染器 (如果有内容或不在加载中) -->
						<div class="chat-msg-text agent-message"
							:class="{ 'agent-error-message': msgInfo.type === 'error' }"
							v-else-if="isAgentMessage && (msgInfo.content || !msgInfo.streaming)">
							<unified-message-renderer
								:message="agentMessageObject"
								:force-format="'markdown'"
								:show-enhancements="false"
								@rendered="onMessageRendered"
							/>
						</div>
						<!-- 流式智能体消息但还没内容时，显示加载动效（排除结构化消息） -->
						<div class="chat-msg-text agent-message" v-else-if="isAgentMessage && msgInfo.streaming && !msgInfo.content && !msgInfo._isStructured">
							<loading-dots />
						</div>
						<!-- 🔥 转发消息卡片 -->
						<ForwardMessageCard
							v-if="isForwardMessage && forwardData"
							:forwardData="forwardData"
							@open-detail="openForwardDetail"
						/>
						<!-- 普通文本消息 -->
						<span class="chat-msg-text" v-else-if="msgInfo.type == $enums.MESSAGE_TYPE.TEXT && !isForwardMessage"
							:key="'text-' + msgInfo.id"
							ref="messageText"></span>
						<span class="chat-msg-text" v-else-if="msgInfo.type == $enums.MESSAGE_TYPE.TIP_TEXT"
							:key="'tip-' + msgInfo.id">{{ msgInfo.content }}</span>
						<div class="chat-msg-image" v-if="msgInfo.type == $enums.MESSAGE_TYPE.IMAGE">
							<div class="img-load-box" v-loading="loading" element-loading-text="上传中.."
								element-loading-background="rgba(0, 0, 0, 0.4)">
								<img class="send-image" :src="JSON.parse(msgInfo.content).thumbUrl"
									@click="showFullImageBox()" loading="lazy" />
							</div>
							<span title="发送失败" v-show="loadFail" @click="onSendFail"
								class="send-fail el-icon-warning"></span>
						</div>
						<!-- 视频文件：显示封面预览 -->
						<div class="chat-msg-video" v-if="msgInfo.type == $enums.MESSAGE_TYPE.FILE && isVideoFile" @click="onFileDownloadClick">
							<div class="video-preview-box">
								<video class="video-thumbnail" :src="data.url" preload="metadata"></video>
								<div class="video-play-overlay">
									<div class="play-button">
										<i class="el-icon-video-play"></i>
									</div>
								</div>
								<div class="video-info">
									<span class="video-name">{{ data.name }}</span>
								</div>
							</div>
						</div>
						<!-- 非视频文件：显示文件图标 -->
						<div class="chat-msg-file" v-else-if="msgInfo.type == $enums.MESSAGE_TYPE.FILE">
							<div class="chat-file-box" v-loading="loading">
								<div class="chat-file-info">
									<el-link class="chat-file-name" :underline="false" type="primary"
										:href="(shouldOpenInVoid || isCurrentFileOffice) ? 'javascript:void(0)' : data.url"
										:download="(shouldOpenInVoid || isCurrentFileOffice) ? undefined : data.name"
										:target="(shouldOpenInVoid || isCurrentFileOffice) ? undefined : '_blank'"
										@click.native="onFileDownloadClick">{{ data.name }}</el-link>
									<div class="chat-file-size">{{ fileSize }}</div>
								</div>
								<div class="chat-file-icon">
									<FileIcon :fileName="data.name" :size="44" />
								</div>
							</div>
							<span title="发送失败" v-show="loadFail" @click="onSendFail"
								class="send-fail el-icon-warning"></span>
						</div>
					</div>
					<div class="chat-msg-voice" v-if="msgInfo.type == $enums.MESSAGE_TYPE.AUDIO" @click="onPlayVoice()">
						<audio controls :src="JSON.parse(msgInfo.content).url"></audio>
					</div>
					<div class="chat-action chat-msg-text" v-if="isAction">
						<span v-if="msgInfo.type == $enums.MESSAGE_TYPE.ACT_RT_VOICE" title="重新呼叫"
							@click="$emit('call')" class="iconfont icon-chat-voice"></span>
						<span v-if="msgInfo.type == $enums.MESSAGE_TYPE.ACT_RT_VIDEO" title="重新呼叫"
							@click="$emit('call')" class="iconfont icon-chat-video"></span>
						<span>{{ msgInfo.content }}</span>
					</div>
					<div class="chat-msg-status" v-if="!isAction">
						<span class="chat-readed" v-show="msgInfo.selfSend && !msgInfo.groupId
							&& msgInfo.status == $enums.MESSAGE_STATUS.READED">已读</span>
						<span class="chat-unread" v-show="msgInfo.selfSend && !msgInfo.groupId
							&& msgInfo.status != $enums.MESSAGE_STATUS.READED">未读</span>
					</div>
					<div class="chat-receipt" v-show="msgInfo.receipt" @click="onShowReadedBox">
						<span v-if="msgInfo.receiptOk" class="icon iconfont icon-ok" title="全体已读"></span>
						<span v-else>{{ msgInfo.readedCount }}人已读</span>
					</div>
					<!-- 🔥 引用消息 + 智能体任务状态 横向布局 -->
					<div v-if="hasQuotedMessages || hasAgentTaskStatus" class="quote-and-status-row">
						<!-- 引用消息显示 -->
						<quoted-message
							v-if="hasQuotedMessages"
							:messages="quotedMessagesList"
							:show-close="false"
							@open-detail="openQuoteDetail"
							class="message-quoted-display"
						/>
						<!-- 箭头连接器（引用和状态之间） -->
						<span v-if="hasQuotedMessages && hasAgentTaskStatus" class="arrow-connector">{{ mine ? '←' : '→' }}</span>
						<!-- 智能体任务状态卡片 -->
						<agent-task-status-card
							v-if="hasAgentTaskStatus"
							:task-status-data="agentTaskStatusData"
							@confirmation-submit="handleConfirmationSubmit"
						@open-detail-panel="handleOpenAgentDetailPanel"
							class="message-agent-task-status"
						/>
					</div>
				</div>
			</div>
		</div>
		<right-menu v-show="menu && rightMenu.show" :pos="rightMenu.pos" :items="menuItems"
			@close="rightMenu.show = false" @select="onSelectMenu"></right-menu>
		<chat-group-readed ref="chatGroupReadedBox" :msgInfo="msgInfo" :groupMembers="groupMembers"></chat-group-readed>

		<!-- 🔥 完整终端弹窗 -->
		<full-terminal-dialog
			v-if="fullTerminalVisible"
			:visible.sync="fullTerminalVisible"
			:stream-id="currentTerminalData.streamId"
			:agent="currentAgent"
			:allow-manual-input="true"
			:initial-output="currentTerminalData.content"
			:cwd="currentTerminalData.cwd"
		/>

	<!-- 🔥 智能体任务详情面板 -->
	<agent-task-detail-panel
		:visible.sync="agentDetailPanelVisible"
		:task-status-data="currentTaskDetail"
		@close="handleCloseAgentDetailPanel"
	/>

	<!-- 🎬 视频播放器 -->
	<video-player
		:visible.sync="videoPlayerVisible"
		:video-url="currentVideoUrl"
		:title="currentVideoTitle"
	/>
	</div>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";
import RightMenu from '../common/RightMenu.vue';
import ChatGroupReaded from './ChatGroupReaded.vue';
import FileIcon from '../common/FileIcon.vue';
import LoadingDots from '../common/LoadingDots.vue';
import RooCodeTaskMessage from './RooCodeTaskMessage.vue';
import FullTerminalDialog from '../agent/FullTerminalDialog.vue';
import VSCodeAdapter from '../../api/vscode-adapter.js';
import { UnifiedMessageRenderer } from '../message';
import { isOfficeFile, openOfficeFileFromMessage, openOfficeFileFromMessageDirectly } from '../../utils/onlyOfficeUtils.js';
import MessageCheckbox from './MessageCheckbox.vue';
import ForwardMessageCard from './ForwardMessageCard.vue';
import QuotedMessage from './QuotedMessage.vue';
import AgentTaskStatusCard from './AgentTaskStatusCard.vue';
import AgentTaskDetailPanel from './AgentTaskDetailPanel.vue';
import VideoPlayer from '../common/VideoPlayer.vue';
import { isForwardMessage, parseForwardMessage, isQuotedMessage, parseQuotedMessage, isAgentTaskStatus, parseAgentTaskStatus, isAgentMentionMessage, parseAgentMentionMessage } from '@/api/messageStructures';

// 全局适配器实例，避免重复初始化
const globalAdapter = VSCodeAdapter;

export default {
	name: "messageItem",
	components: {
		HeadImage,
		RightMenu,
		ChatGroupReaded,
		FileIcon,
		LoadingDots,
		RooCodeTaskMessage,
		FullTerminalDialog,
		UnifiedMessageRenderer,
		MessageCheckbox,
		ForwardMessageCard,
		QuotedMessage,
		AgentTaskStatusCard,
		AgentTaskDetailPanel,
		VideoPlayer
	},
	props: {
		mode: {
			type: Number,
			default: 1
		},
		mine: {
			type: Boolean,
			required: true
		},
		headImage: {
			type: String,
			required: true
		},
		showName: {
			type: String,
			required: true
		},
		msgInfo: {
			type: Object,
			required: true
		},
		groupMembers: {
			type: Array
		},
		menu: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			audioPlayState: 'STOP',
			rightMenu: {
				show: false,
				pos: {
					x: 0,
					y: 0
				}
			},
			lastRenderedContent: null, // 缓存上次渲染的内容
			autoDownloadAttempted: false, // 防止重复自动下载

			// 🔥 完整终端弹窗相关
			fullTerminalVisible: false,
			currentTerminalData: {
				streamId: '',
				content: '',
				cwd: '~',
				taskId: ''
			},

			// 🔥 智能体任务详情面板相关
			agentDetailPanelVisible: false,
			currentTaskDetail: null,

			// 🎬 视频播放器相关
			videoPlayerVisible: false,
			currentVideoUrl: '',
			currentVideoTitle: ''
		}
	},
	mounted() {
		// 🔍 调试日志：验证组件接收到的数据
		if (this.hasAgentTaskStatus && this.agentTaskStatusData) {
			console.log('[DEBUG-PERSIST] ChatMessageItem mounted - 检测到智能体任务消息:', {
				messageId: this.msgInfo.id || this.msgInfo.tmpId,
				taskId: this.agentTaskStatusData.taskId,
				type: this.agentTaskStatusData.type,
				status: this.agentTaskStatusData.status
			});
		}

		// 只在首次挂载时渲染
		this.renderMessageText();

		// 🔧 VSCode环境下的文本选择优化
		this.initTextSelectionOptimization();

		// 🚀 自动下载接收到的文件
		this.autoDownloadReceivedFile();
	},
	updated() {
		// 如果消息类型变成了 TIP_TEXT（撤回消息），清空缓存
		if (this.msgInfo.type === this.$enums.MESSAGE_TYPE.TIP_TEXT) {
			this.lastRenderedContent = null;
		}
		
		// 只在消息内容实际变化时重新渲染
		this.smartRenderMessageText();
		
		// 🔧 确保文本选择优化在组件更新后仍然有效
		this.$nextTick(() => {
			this.optimizeTextSelection();
		});
	},
	methods: {
		/**
		 * 🚀 自动下载接收到的文件消息（不包括自己发送的）
		 */
		async autoDownloadReceivedFile() {
			try {
				// 1. 防止重复下载
				if (this.autoDownloadAttempted) {
					return;
				}

				// 2. 只处理文件类型消息
				if (this.msgInfo.type !== this.$enums.MESSAGE_TYPE.FILE) {
					return;
				}

				// 3. 🔥 关键判断：通过 sendId 判断是否为自己发送的
				// 获取当前用户ID
				const currentUserId = this.$store?.state?.userStore?.userInfo?.id;
				if (!currentUserId) {
					return;
				}

				// 比较 sendId，如果是自己发送的则跳过
				const sendId = parseInt(this.msgInfo.sendId);
				if (sendId === parseInt(currentUserId)) {
					return;
				}

				// 4. 检查是否在void环境中
				const isVoidEnv = !!(window.vscodeServices || this.$vscode);
				if (!isVoidEnv) {
					return;
				}

				// 4.5 🔥 检查此消息是否已经下载过（从消息对象读取）
				if (this.msgInfo.autoDownloaded) {
					return;
				}

				// 5. 检查文件信息是否有效
				const fileUrl = this.data?.url;
				const fileName = this.data?.name;

				if (!fileUrl || !fileName) {
					return;
				}

				// 6. 可选：文件大小限制（避免自动下载超大文件）
				const MAX_AUTO_DOWNLOAD_SIZE = 100 * 1024 * 1024; // 100MB
				if (this.data.size && this.data.size > MAX_AUTO_DOWNLOAD_SIZE) {
					return;
				}

				// 7. 标记已尝试下载
				this.autoDownloadAttempted = true;

				// 8. 执行自动下载
				const result = await this.saveRemoteFileToWorkspace(fileUrl, fileName);

				if (result && result.success) {
					this.$set(this.msgInfo, 'autoDownloaded', true);
					this.$set(this.msgInfo, 'downloadedFilePath', result.filePath);
					this.$emit('message-updated', this.msgInfo);
				}

			} catch (error) {
				// 自动下载失败（静默处理）
			}
		},

		/**
		 * 🔥 处理任务完成事件，转发 renderItems 给父组件
		 */
		onTaskCompleted(data) {
			this.$emit('task-completed', { msgInfo: this.msgInfo, renderItems: data.renderItems });
		},

		/**
		 * 🔥 处理智能体任务状态卡片点击 - 打开Happy任务详情面板
		 */
		handleOpenAgentDetailPanel(taskStatusData) {
			console.log('[任务详情debug] 🎯 ChatMessageItem 收到打开详情面板事件:', taskStatusData);
			
			// 转发事件到父组件 ChatBox
			this.$emit('open-agent-task-detail', {
				taskStatusData,
				msgInfo: this.msgInfo
			});
			
			console.log('[任务详情debug] ✅ ChatMessageItem 已发送事件到父组件');
		},

		/**
		 * 🔧 初始化文本选择优化 - 解决VSCode环境下无法选中文本的问题
		 */
		initTextSelectionOptimization() {
			try {
				// 检测VSCode环境
				const isVSCodeEnv = typeof window !== 'undefined' &&
					(window.vscodeVueChatUtils !== undefined ||
					 window.vscodeServices !== undefined ||
					 window.acquireVsCodeApi !== undefined);

				if (isVSCodeEnv) {
					// 为根元素添加VSCode环境标识类
					if (this.$el) {
						this.$el.classList.add('vscode-environment');
					}

					// 等待DOM更新后处理文本元素
					this.$nextTick(() => {
						this.optimizeTextSelection();
					});
				}
			} catch (error) {
				// 初始化失败（静默处理）
			}
		},

		/**
		 * 🔧 优化文本选择 - 确保消息文本可以被选中复制
		 */
		optimizeTextSelection() {
			const messageTextElement = this.$refs.messageText;
			if (messageTextElement) {
				// 强制设置文本选择样式
				messageTextElement.style.userSelect = 'text';
				messageTextElement.style.webkitUserSelect = 'text';
				messageTextElement.style.mozUserSelect = 'text';
				messageTextElement.style.msUserSelect = 'text';
				messageTextElement.style.cursor = 'text';
				messageTextElement.style.pointerEvents = 'auto';
				
				// 添加CSS类标识
				messageTextElement.classList.add('text-selectable');
				
				// 阻止某些可能干扰文本选择的事件
				messageTextElement.addEventListener('selectstart', function(e) {
					e.stopPropagation();
				}, true);
				
				messageTextElement.addEventListener('mousedown', function(e) {
					// 允许左键点击进行文本选择
					if (e.button === 0) {
						e.stopPropagation();
					}
				}, true);
			}
		},

		/**
		 * 智能渲染消息文本内容（避免不必要的重渲染）
		 */
		smartRenderMessageText() {
			if (!this.$refs.messageText || this.msgInfo.type !== this.$enums.MESSAGE_TYPE.TEXT) {
				return;
			}

			// 只有内容真正变化时才重新渲染
			if (this.htmlText !== this.lastRenderedContent) {
				this.renderMessageText();
			}
		},

		/**
		 * 高性能渲染消息文本内容
		 */
		renderMessageText() {
			if (!this.$refs.messageText || this.msgInfo.type !== this.$enums.MESSAGE_TYPE.TEXT) {
				return;
			}
			
			try {
				// 使用全局适配器实例，避免重复初始化
				globalAdapter.setInnerHTML(this.$refs.messageText, this.htmlText);
				this.lastRenderedContent = this.htmlText;
				
				// 🔧 渲染后确保文本选择优化（VSCode环境）
				this.$nextTick(() => {
					this.optimizeTextSelection();
				});
			} catch (error) {
				// 静默降级处理：使用纯文本
				this.$refs.messageText.textContent = this.msgInfo.content;
				this.lastRenderedContent = this.msgInfo.content;
				
				// 即使降级处理也要确保文本可选择
				this.$nextTick(() => {
					this.optimizeTextSelection();
				});
			}
		},
		onSendFail() {
			this.$message.error("该文件已发送失败，目前不支持自动重新发送，建议手动重新发送")
		},
		showFullImageBox() {
			let imageUrl = JSON.parse(this.msgInfo.content).originUrl;
			if (imageUrl) {
				// 收集当前会话的所有图片
				const chatStore = this.$store.state.chatStore;
				const currentChat = chatStore.activeChat;
				let imageList = [];
				let currentIndex = 0;
				
				if (currentChat) {
					// 从 chats 数组中找到当前会话
					const chat = chatStore.chats.find(c => c.targetId === currentChat.targetId);
					
					if (chat && chat.messages) {
						const messages = chat.messages;
						
						// 遍历消息，收集所有图片
						messages.forEach((msg) => {
							if (msg.type === this.$enums.MESSAGE_TYPE.IMAGE) {
								try {
									const content = JSON.parse(msg.content);
									if (content.originUrl) {
										imageList.push(content.originUrl);
										// 如果是当前点击的图片，记录索引
										if (content.originUrl === imageUrl) {
											currentIndex = imageList.length - 1;
										}
									}
								} catch (e) {
									// 忽略解析错误
								}
							}
						});
					}
				}
				
				// 如果没有收集到图片列表，至少包含当前图片
				if (imageList.length === 0) {
					imageList = [imageUrl];
					currentIndex = 0;
				}
				
				// 传入图片列表和当前索引
				this.$store.commit('showFullImageBox', {
					url: imageUrl,
					imageList: imageList,
					index: currentIndex
				});
				
				// 同时保存图片到工作区
				this.saveImageToWorkspace(imageUrl);
			}
		},
		async saveImageToWorkspace(imageUrl) {
			try {
				// 使用Vue服务访问框架获取VSCode服务
				if (this.$vscode && imageUrl) {
					// 下载图片内容
					const response = await fetch(imageUrl);
					const arrayBuffer = await response.arrayBuffer();
					const uint8Array = new Uint8Array(arrayBuffer);

					// 从URL中提取文件扩展名，或者根据content-type推断
					const contentType = response.headers.get('content-type') || '';
					let extension = '.jpg'; // 默认扩展名
					if (contentType.includes('png')) extension = '.png';
					else if (contentType.includes('gif')) extension = '.gif';
					else if (contentType.includes('webp')) extension = '.webp';

					// 生成图片文件名，尝试从URL中提取原始名称
					let fileName = `image${extension}`;
					try {
						const url = new URL(imageUrl);
						const pathParts = url.pathname.split('/');
						const lastPart = pathParts[pathParts.length - 1];
						if (lastPart && lastPart.includes('.')) {
							fileName = lastPart;
						}
					} catch (e) {
						// 如果URL解析失败，使用默认名称
					}

					// 获取会话ID
					const sessionId = this.msgInfo.groupId || this.msgInfo.targetId || 'unknown';

					// 使用 SharedServicesAccessor 的 saveArrayBufferToWorkspace 方法
					await this.$vscode.saveArrayBufferToWorkspace(uint8Array, fileName, sessionId);
				}
			} catch (error) {
				// 保存失败（静默处理）
			}
		},
		onPlayVoice() {
			if (!this.audio) {
				this.audio = new Audio();
			}
			this.audio.src = JSON.parse(this.msgInfo.content).url;
			this.audio.play();
			this.onPlayVoice = 'RUNNING';
		},
		showRightMenu(e) {
			// 由于父容器有 transform 属性，需要计算正确的偏移量
			// 查找最近的有 transform 的父容器
			let element = e.target;
			let offsetX = 0;
			let offsetY = 0;

			while (element && element !== document.body) {
				const style = window.getComputedStyle(element);
				if (style.transform && style.transform !== 'none') {
					const rect = element.getBoundingClientRect();
					offsetX = rect.left;
					offsetY = rect.top;
					break;
				}
				element = element.parentElement;
			}

			this.rightMenu.pos = {
				x: e.clientX - offsetX,
				y: e.clientY - offsetY
			};
			this.rightMenu.show = "true";
		},
		onSelectMenu(item) {
			// 如果是复制操作，直接在这里处理
			if (item.key === 'COPY') {
				this.copyMessageContent();
				return;
			}
			// 🔥 如果是多选操作，进入多选模式
			if (item.key === 'MULTI_SELECT') {
				this.enterMultiSelectMode();
				return;
			}
			// 🔥 如果是引用操作，触发引用事件
			if (item.key === 'QUOTE') {
				this.$emit('quote', this.msgInfo);
				return;
			}
			this.$emit(item.key.toLowerCase(), this.msgInfo);
		},
		// 🔥 复制消息内容
		copyMessageContent() {
			try {
				// 获取纯文本内容
				let cleanContent = this.msgInfo.content || '';

				// 复制到剪贴板
				if (navigator.clipboard && navigator.clipboard.writeText) {
					navigator.clipboard.writeText(cleanContent).then(() => {
						this.$message.success('已复制到剪贴板');
					}).catch(() => {
						// 降级方案
						this.fallbackCopyToClipboard(cleanContent);
					});
				} else {
					// 降级方案
					this.fallbackCopyToClipboard(cleanContent);
				}
			} catch (error) {
				this.$message.error('复制失败');
			}
		},
		// 降级复制方案（兼容老旧浏览器）
		fallbackCopyToClipboard(text) {
			const textArea = document.createElement('textarea');
			textArea.value = text;
			textArea.style.position = 'fixed';
			textArea.style.left = '-9999px';
			document.body.appendChild(textArea);
			textArea.select();
			try {
				document.execCommand('copy');
				this.$message.success('已复制到剪贴板');
			} catch (err) {
				this.$message.error('复制失败');
			}
			document.body.removeChild(textArea);
		},
		onShowReadedBox() {
			let rect = this.$refs.chatMsgBox.getBoundingClientRect();
			this.$refs.chatGroupReadedBox.open(rect);
		},
		async onFileDownloadClick() {
			try {
				const fileName = this.data.name;
				
				// 🎬 视频文件：打开视频播放器
				if (this.isVideoFile) {
					this.currentVideoUrl = this.data.url;
					this.currentVideoTitle = fileName;
					this.videoPlayerVisible = true;
					return;
				}
				
				// ✅ 优先检测：Office 文件双击预览（直接使用Minio URL，不经过后端API）
				if (fileName && isOfficeFile(fileName)) {
					try {
						await openOfficeFileFromMessageDirectly({
							msgInfo: this.msgInfo,
							store: this.$store  // 传递store以获取用户信息
						});
						return;
					} catch (error) {
						// OnlyOffice 打开失败，继续执行下面的下载逻辑
						this.$message.error('无法打开 Office 文件预览：' + error.message);
					}
				}

				// ✅ 非 Office 文件：保持原有的下载逻辑
				const isVoidEnv = !!(window.vscodeServices || this.$vscode);
				if (!isVoidEnv) {
					// 非void环境：el-link的href会处理下载
					return;
				}

				// void环境 + 已下载：打开预览
				if (this.msgInfo.autoDownloaded && this.msgInfo.downloadedFilePath) {
					await this.openFileInVoid(this.msgInfo.downloadedFilePath);
					return;
				}

				// void环境 + 未下载：下载并保存
				const fileUrl = this.data.url;

				if (fileUrl && fileName) {
					const result = await this.saveRemoteFileToWorkspace(fileUrl, fileName);
					if (result && result.success) {
						this.$set(this.msgInfo, 'autoDownloaded', true);
						this.$set(this.msgInfo, 'downloadedFilePath', result.filePath);
						this.$emit('message-updated', this.msgInfo);
					}
				}
			} catch (error) {
				// 文件点击处理失败（静默处理）
			}
		},
		async saveRemoteFileToWorkspace(fileUrl, fileName) {
			try {
				const vscodeServices = window.vscodeServices;
				if (!vscodeServices) {
					return false;
				}

				// 下载文件内容
				const response = await fetch(fileUrl);
				const arrayBuffer = await response.arrayBuffer();

				// 将 ArrayBuffer 转换为 File 对象
				const blob = new Blob([arrayBuffer]);
				const file = new File([blob], fileName, { type: blob.type || 'application/octet-stream' });

				// 获取会话信息
				const sessionInfo = {
					id: this.msgInfo.groupId || this.msgInfo.targetId,
					targetId: this.msgInfo.groupId || this.msgInfo.targetId,
					type: this.msgInfo.groupId ? 'GROUP' : 'PRIVATE'
				};

				// 使用 ChatWorkspaceService 的 uploadFilesToSession 方法
				const chatWorkspaceService = vscodeServices.get('IChatWorkspaceService');
				if (!chatWorkspaceService) {
					return false;
				}

				const results = await chatWorkspaceService.uploadFilesToSession([file], sessionInfo);

				if (results && results.length > 0 && results[0].success) {
					return {
						success: true,
						filePath: results[0].filePath,
						uri: results[0].uri
					};
				} else {
					return { success: false };
				}

			} catch (error) {
				return { success: false };
			}
		},

		/**
		 * 在void中打开文件预览
		 */
		async openFileInVoid(filePath) {
			try {
				const vscodeServices = window.vscodeServices;
				if (!vscodeServices || !vscodeServices.get) {
					return false;
				}

				const commandService = vscodeServices.get('ICommandService');
				if (!commandService) {
					return false;
				}

				// 使用 vscode.open 命令打开文件
				// 对于文本文件会在编辑器中打开，对于二进制文件会用系统默认程序打开
				await commandService.executeCommand('vscode.open', { scheme: 'file', path: filePath });

				return true;
			} catch (error) {
				return false;
			}
		},

		handleContextMenu(event) {
			// 阻止默认的右键菜单
			event.preventDefault();
			// 阻止文本选择
			event.stopPropagation();
			// 显示右键菜单
			this.showRightMenu(event);
		},
		// Markdown消息渲染完成回调
		onMessageRendered() {
			// 触发消息渲染完成事件
			this.$emit('message-rendered', this.msgInfo);
			// 确保消息滚动到可视区域
			this.$nextTick(() => {
				this.$emit('need-scroll');
			});
		},

		/**
		 * 打开完整终端弹窗
		 */
		handleOpenTerminal(data) {
			// 确保 content 是字符串，处理可能的 reactive getter
			const content = typeof data.content === 'string' ? data.content : String(data.content || '');

			// 🔥 使用 section 中保存的真实 WebSocket streamId
			// data.streamId 现在应该是 AgentSessionManager 从 chunk 中获取的真实 streamId
			this.currentTerminalData = {
				streamId: data.streamId,
				content: content,
				cwd: data.cwd || '~',
				taskId: data.taskId
			};

			this.fullTerminalVisible = true;
		},

		/**
		 * 🔥 中止命令执行
		 */
		async handleAbortCommand(data) {
			try {
				// 通过 AgentSessionManager 发送中止信号
				if (this.$agentSessionManager) {
					await this.$agentSessionManager.abortCommand(data.streamId || data.taskId);
					this.$message.success('已发送中止信号');
				} else {
					this.$message.error('中止功能不可用');
				}
			} catch (error) {
				this.$message.error('中止失败: ' + error.message);
			}
		},

		// 🔥 多选模式相关方法
		enterMultiSelectMode() {
			const chat = this.$store.state.chatStore.activeChat;
			if (chat) {
				this.$store.commit('enterMultiSelectMode', chat.targetId);
				// 自动选中当前消息
				const messageId = this.msgInfo.id || this.msgInfo.tmpId;
				this.$store.commit('toggleMessageSelection', messageId);
			}
		},
		handleMessageClick() {
			if (this.isMultiSelectMode) {
				this.toggleSelection();
			}
		},
		toggleSelection() {
			const messageId = this.msgInfo.id || this.msgInfo.tmpId;
			this.$store.commit('toggleMessageSelection', messageId);
		},
		openForwardDetail() {
			// 发出事件给父组件处理，而不是路由跳转
			this.$emit('open-forward-detail', {
				messageId: this.msgInfo.id || this.msgInfo.tmpId,
				forwardData: this.forwardData
			});
		},
		openQuoteDetail() {
			// 🔥 打开引用详情，复用转发详情弹窗
			this.$emit('open-quote-detail', {
				messageId: this.msgInfo.id || this.msgInfo.tmpId,
				quotedMessages: this.quotedMessagesList
			});
		},

		// 🔥 处理智能体任务确认问题提交
		handleConfirmationSubmit(answer) {
			this.$emit('agent-confirmation-submit', {
				taskId: this.agentTaskStatusData?.taskId,
				answer
			});
		},

		// 🔥 处理详情面板关闭
		handleCloseAgentDetailPanel() {
			this.agentDetailPanelVisible = false;
		}
	},
	computed: {
		loading() {
			return this.msgInfo.loadStatus && this.msgInfo.loadStatus === "loading";
		},
		loadFail() {
			return this.msgInfo.loadStatus && this.msgInfo.loadStatus === "fail";
		},
		data() {
			return JSON.parse(this.msgInfo.content)
		},
		/**
		 * 判断当前文件是否为 Office 文件
		 */
		isCurrentFileOffice() {
			if (this.msgInfo.type !== this.$enums.MESSAGE_TYPE.FILE) {
				return false;
			}
			const fileName = this.data?.name;
			if (!fileName) {
				return false;
			}
			return isOfficeFile(fileName);
		},
		/**
		 * 🔥 判断是否应该在void中打开预览（而不是浏览器下载）
		 */
		shouldOpenInVoid() {
			const isVoidEnv = !!(window.vscodeServices || this.$vscode);
			const isDownloaded = this.msgInfo.autoDownloaded && this.msgInfo.downloadedFilePath;
			return isVoidEnv && isDownloaded;
		},
		fileSize() {
			let size = this.data.size;
			// 如果 size 不存在或不是数字，返回未知
			if (!size || typeof size !== 'number') {
				return '未知大小';
			}
			// 转换为数字（防止字符串）
			size = Number(size);
			if (isNaN(size)) {
				return '未知大小';
			}
			// MB
			if (size >= 1024 * 1024) {
				return (size / 1024 / 1024).toFixed(2) + "M";
			}
			// KB
			if (size >= 1024) {
				return (size / 1024).toFixed(2) + "KB";
			}
			// B
			return size + "B";
		},
		isVideoFile() {
			if (!this.data || !this.data.name) return false;
			const fileName = this.data.name.toLowerCase();
			const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.mkv', '.flv', '.m3u8', '.ts', '.m4v', '.wmv', '.mpg', '.mpeg'];
			return videoExtensions.some(ext => fileName.endsWith(ext));
		},
		menuItems() {
			let items = [];
			// 🔥 添加多选选项（排除时间提示消息）
			if (this.msgInfo.type !== this.$enums.MESSAGE_TYPE.TIP_TIME &&
			    this.msgInfo.type !== this.$enums.MESSAGE_TYPE.TIP_TEXT) {
				items.push({
					key: 'MULTI_SELECT',
					name: '多选',
					icon: 'el-icon-finished'
				});
			}
			// 🔥 添加引用选项（排除时间提示消息）
			if (this.msgInfo.type !== this.$enums.MESSAGE_TYPE.TIP_TIME &&
			    this.msgInfo.type !== this.$enums.MESSAGE_TYPE.TIP_TEXT) {
				items.push({
					key: 'QUOTE',
					name: '引用',
					icon: 'el-icon-chat-line-square'
				});
			}
			// 🔥 如果是文本消息，添加复制选项
			if (this.msgInfo.type === this.$enums.MESSAGE_TYPE.TEXT && this.msgInfo.content) {
				items.push({
					key: 'COPY',
					name: '复制',
					icon: 'el-icon-document-copy'
				});
			}
			items.push({
				key: 'DELETE',
				name: '删除',
				icon: 'el-icon-delete'
			});
			if (this.msgInfo.selfSend && this.msgInfo.id > 0) {
				items.push({
					key: 'RECALL',
					name: '撤回',
					icon: 'el-icon-refresh-left'
				});
			}
			return items;
		},
		isAction() {
			return this.$msgType.isAction(this.msgInfo.type);
		},
		isNormal() {
			const type = this.msgInfo.type;
			return this.$msgType.isNormal(type) || this.$msgType.isAction(type)
		},
		// 判断是否为智能体消息
		messageTimeText() {
			if (!this.msgInfo || !this.msgInfo.sendTime) {
				return '';
			}
			return this.$date.toTimeText(this.msgInfo.sendTime);
		},
		structuredChunks() {
			return this.msgInfo._structuredChunks || [];
		},
		hasStructuredError() {
			return this.structuredChunks.some(chunk => chunk.type === 'error');
		},
		isStructuredStreaming() {
			if (this.msgInfo.streaming) {
				return true;
			}
			return this.structuredChunks.some(chunk => chunk.partial === true);
		},
		isAgentMessage() {
			// 检查多种可能的标记字段
			return (this.msgInfo.type === this.$enums.MESSAGE_TYPE.TEXT || this.msgInfo.type === 'error') && (
				this.msgInfo.isAgent || 
				this.msgInfo.isAI ||
				this.msgInfo.fromAgent ||
				this.msgInfo.agentId ||
				this.msgInfo.modelName ||
				(this.msgInfo.sendId && String(this.msgInfo.sendId).startsWith('agent_')) ||
				(this.msgInfo.extra && this.msgInfo.extra.isAgent)
			);
		},
		// 构建智能体消息对象
		agentMessageObject() {
			return {
				content: this.msgInfo.content || '',
				type: this.msgInfo.type === 'error' ? 'ERROR' : 'AGENT',
				format: 'markdown',
				isAgent: true,
				isError: this.msgInfo.type === 'error',
				msgInfo: this.msgInfo,
				sendId: this.msgInfo.sendId,
				agentId: this.msgInfo.agentId,
				modelName: this.msgInfo.modelName
			};
		},
		htmlText() {
			let color = this.msgInfo.selfSend ? 'white' : '';
			// 🔥 使用 displayContent 获取实际文本（排除引用结构）
			let cleanContent = this.displayContent;
			// 🔥 将换行符转换为 <br> 标签，以便正确显示
			cleanContent = cleanContent.replace(/\n/g, '<br>');
			let text = this.$url.replaceURLWithHTMLLinks(cleanContent, color)
			return this.$emo.transform(text,'emoji-normal')
		},
		isTipMessage() {
			return this.msgInfo.type === this.$enums.MESSAGE_TYPE.TIP_TIME;
		},
		/**
		 * 🔥 当前智能体信息（用于终端弹窗）
		 */
		currentAgent() {
			// 从 msgInfo 中提取智能体信息
			if (this.msgInfo.agentId || this.msgInfo.sendId) {
				return {
					id: this.msgInfo.agentId || this.msgInfo.sendId,
					name: this.showName || '智能体',
					avatar: this.headImage || '',
					mode: this.msgInfo.agentMode || 'code'
				};
			}
			// 默认智能体信息
			return {
				id: 'default',
				name: this.showName || '智能体',
				avatar: this.headImage || '',
				mode: 'code'
			};
		},
		// 🔥 多选模式相关计算属性
		isMultiSelectMode() {
			return this.$store.state.chatStore.multiSelectMode.active;
		},
		isSelected() {
			const messageId = this.msgInfo.id || this.msgInfo.tmpId;
			return this.$store.state.chatStore.multiSelectMode.selectedMessages.includes(messageId);
		},
		// 🔥 转发消息相关计算属性
		isForwardMessage() {
			return isForwardMessage(this.msgInfo);
		},
		forwardData() {
			return parseForwardMessage(this.msgInfo);
		},
		// 🔥 是否有引用消息（检查结构化内容）
		hasQuotedMessages() {
			return isQuotedMessage(this.msgInfo) || 
				(this.agentMentionData && this.agentMentionData.quotedMessages && this.agentMentionData.quotedMessages.length > 0);
		},
		// 🔥 解析引用消息数据
		quotedData() {
			return parseQuotedMessage(this.msgInfo);
		},
		// 🔥 获取引用消息列表（用于QuotedMessage组件）
		quotedMessagesList() {
			if (this.quotedData) return this.quotedData.quotedMessages || [];
			if (this.agentMentionData && this.agentMentionData.quotedMessages) return this.agentMentionData.quotedMessages;
			return [];
		},
		// 🔥 获取实际显示的文本内容（排除引用结构）
		displayContent() {
			if (this.quotedData) {
				return this.quotedData.text || '';
			}
			if (this.agentMentionData) {
				const mention = this.agentMentionData.agentMention;
				const text = this.agentMentionData.text || '';
				return mention ? `@智能体[${mention.agentName}] ${text}` : text;
			}
			return this.msgInfo.content || '';
		},

		// 🔥 @智能体提及消息相关
		isAgentMentionMessage() {
			return isAgentMentionMessage(this.msgInfo);
		},
		agentMentionData() {
			return parseAgentMentionMessage(this.msgInfo);
		},

		// 🔥 检测是否为AGENT_TASK_STATUS消息（需要隐藏）
		isAgentTaskStatusMessage() {
			return isAgentTaskStatus(this.msgInfo);
		},

		// 🔥 是否有智能体任务状态
		hasAgentTaskStatus() {
			// 只有AGENT_MENTION消息才显示状态卡片
			return this.isAgentMentionMessage;
		},

		// 解析智能体任务状态数据
		agentTaskStatusData() {
			if (!this.isAgentMentionMessage) {
				return null;
			}

			const mentionData = this.agentMentionData;
			if (!mentionData || !mentionData.agentMention) {
				return null;
			}

			const taskId = mentionData.agentMention.taskId;
			if (!taskId) {
				return null;
			}

			// 🔥 从消息中获取 shareUrl（始终可用）
			const shareUrl = mentionData.agentMention.shareUrl;

			// 从 store 查找状态（使用后端 taskId）
			let latestStatus = this.$store.state.chatStore.agentTaskStatuses[taskId];

			// 如果找到最新状态，使用它；否则返回初始状态
			if (latestStatus) {
				// 🔥 确保 shareUrl 始终存在
				if (shareUrl && !latestStatus.shareUrl) {
					latestStatus.shareUrl = shareUrl;
				}
				return latestStatus;
			}

			// 返回初始状态（确保始终有数据）
			return {
				type: 'AGENT_TASK_STATUS',
				version: '1.0',
				taskId: taskId,
				agentId: mentionData.agentMention.agentId,
				agentName: mentionData.agentMention.agentName,
				shareUrl: shareUrl,
				status: 'initializing',
				statusHistory: [{
					status: 'initializing',
					message: '任务初始化中...',
					timestamp: mentionData.agentMention.createTime || Date.now(),
					collapsed: false
				}],
				createTime: mentionData.agentMention.createTime || Date.now(),
				updateTime: mentionData.agentMention.createTime || Date.now()
			};
		}
	}
}
</script>

<style lang="scss" scoped>
.chat-msg-item {

	// 多选模式选中状态的背景反馈
	&.selected {
		background-color: rgba(0, 0, 0, 0.05);
	}

	.chat-msg-tip {
		line-height: 50px;
		font-size: var(--im-font-size-small);
		color: var(--im-text-color-light);
		text-align: center;
	}

	.chat-msg-normal {
		position: relative;
		font-size: 0;
		padding-left: 48px;
		min-height: 50px;
		margin-top: 10px;
		transition: margin-left 0.2s ease;

		.head-image {
			position: absolute;
			width: 40px;
			height: 40px;
			top: 0;
			left: 0;
		}

		.chat-msg-content {
			text-align: left;

			.send-fail {
				color: #e60c0c;
				font-size: 30px;
				cursor: pointer;
				margin: 0 20px;
			}

			.chat-msg-top {
				display: flex;
				flex-wrap: nowrap;
				color: var(--im-text-color-light);
				font-size: var(--im-font-size);
				line-height: 20px;

				span {
					margin-right: 12px;
				}
			}

			.chat-msg-bottom {
				display: inline-block;
				max-width: min(70%, 500px);
				text-align: left;

				// 🔥 引用面板 + 智能体状态面板 横向布局容器
				.quote-and-status-row {
					display: flex !important;
					flex-direction: row !important;
					align-items: center; // 中线对齐
					gap: 12px;
					margin-top: 8px;
					flex-wrap: nowrap;

					// 箭头连接器样式
					.arrow-connector {
						font-size: 16px;
						color: #909399;
						font-weight: bold;
						flex-shrink: 0;
						padding: 0 4px;
					}

					// 🔥 引用消息显示样式（在横向布局中）
					.message-quoted-display {
						text-align: left;
						flex-shrink: 0;

						::v-deep .quoted-message-wrapper {
							padding: 0 !important;
							display: inline-block;

							.quoted-message-card {
								background: #f5f5f5;
								border-radius: 8px;
								max-width: 250px;
								border: 1px solid #e0e0e0;
							}
						}
					}

					// 🔥 智能体状态面板样式（在横向布局中）
					.message-agent-task-status {
						flex-shrink: 0;

						::v-deep .agent-task-status-wrapper {
							padding: 0 !important;
						}

						::v-deep .status-cards-container {
							justify-content: flex-start;
						}
					}
				}

				// 🔥 仿微信PC版：右键菜单激活时消息气泡的高亮效果
				&.context-menu-active {
					.chat-msg-text,
					.chat-msg-image,
					.chat-msg-file {
						background-color: rgba(0, 0, 0, 0.05);
						transition: background-color 0.15s ease;
					}
				}

				.chat-msg-text {
					display: inline-block;
					position: relative;
					line-height: 26px;
					//margin-top: 3px;
					padding: 6px 10px;
					background-color: var(--im-background);
					border-radius: 10px;
					font-size: var(--im-font-size);
					text-align: left;
					white-space: pre-wrap;
					word-break: break-all;
					max-width: 100%;

					&.structured-message-card {
						padding: 12px 14px;
						// 保持原有的白色背景和阴影效果
						background: #ffffff;
						border-radius: 14px;
						box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);
						border: 1px solid rgba(15, 23, 42, 0.06);
						line-height: 1.6;
						max-width: min(700px, 80vw);

						// 结构化消息的小三角样式 - 与智能体面板箭头保持一致
						&:after {
							left: -6px;
							top: 18px;
							width: 8px;
							height: 8px;
							border-style: solid;
							border-width: 1px 0 0 1px;
							border-color: rgba(15, 23, 42, 0.08);
							border-radius: 0;
							background: #ffffff;
							transform: rotate(-45deg);
							overflow: visible;
						}

						.structured-card-header {
							display: flex;
							align-items: center;
							justify-content: space-between;
							margin-bottom: 12px;
							font-size: 13px;
							color: var(--im-text-color-light, #76808f);

							.structured-card-title {
								display: inline-flex;
								align-items: center;
								gap: 8px;

								.name {
									font-weight: 600;
									color: var(--im-text-color, #1f2933);
								}

							.mode-tag {
								padding: 2px 8px;
								border-radius: 999px;
								font-size: 12px;
								background: rgba(64, 158, 255, 0.12);
								color: var(--im-color-primary, #409eff);
							}
						}

						.time {
							margin-left: auto;
							font-size: 12px;
							opacity: 0.7;
						}
						}
					}

					// Markdown内容样式优化
					::v-deep .unified-message-renderer {
						.message-markdown {
							.markdown-body {
								background: transparent !important;
								padding: 0 !important;
								color: inherit !important;
								
								// 调整标题样式
								h1, h2, h3, h4, h5, h6 {
									margin-top: 8px;
									margin-bottom: 6px;
									
									&:first-child {
										margin-top: 0;
									}
								}
								
								// 调整段落间距
								p {
									margin: 4px 0;
									
									&:last-child {
										margin-bottom: 0;
									}
								}
								
								// 列表样式
								ul, ol {
									margin: 4px 0;
									padding-left: 20px;
								}
								
								// 代码块样式
								.code-block-wrapper {
									margin: 6px -6px;
									border-radius: 4px;
									overflow: hidden;
									
									.code-block-header {
										padding: 4px 8px;
										font-size: 12px;
									}
									
									.code-block-content {
										pre {
											margin: 0;
											padding: 8px;
											background: rgba(0, 0, 0, 0.03);
											
											code {
												font-size: 12px;
											}
										}
									}
								}
								
								// 行内代码
								code:not(pre code) {
									padding: 2px 4px;
									font-size: 85%;
									background-color: rgba(27, 31, 35, 0.05);
									border-radius: 3px;
								}
								
								// 表格样式
								.markdown-table {
									margin: 6px 0;
									font-size: 13px;
									
									th, td {
										padding: 4px 8px;
									}
								}
								
								// 引用样式
								blockquote {
									margin: 6px 0;
									padding: 4px 0 4px 12px;
									border-left-width: 3px;
								}
							}
						}
					}
					
					// 🔧 确保文本可选择 - 解决VSCode环境下无法选中文本的问题
					user-select: text !important;
					-webkit-user-select: text !important;
					-moz-user-select: text !important;
					-ms-user-select: text !important;
					cursor: text;

					&:after {
						content: "";
						position: absolute;
						left: -10px;
						top: 13px;
						width: 0;
						height: 0;
						border-style: solid dashed dashed;
						border-color: #eee transparent transparent;
						overflow: hidden;
						border-width: 10px;
					}
				}

				.chat-msg-image {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;

					.send-image {
						min-width: 200px;
						min-height: 150px;
						max-width: 400px;
						max-height: 300px;
						border-radius: 8px;
						cursor: pointer;
					}

				}


				.chat-msg-video {
					position: relative;
					cursor: pointer;
					margin-bottom: 2px;

					.video-preview-box {
						position: relative;
						width: 240px;
						height: 180px;
						border-radius: 8px;
						overflow: hidden;
						box-shadow: var(--im-box-shadow-light);

						.video-thumbnail {
							width: 100%;
							height: 100%;
							object-fit: cover;
							background: #000;
						}

						.video-play-overlay {
							position: absolute;
							top: 0;
							left: 0;
							right: 0;
							bottom: 0;
							display: flex;
							align-items: center;
							justify-content: center;
							background: rgba(0, 0, 0, 0.3);
							transition: background 0.2s;

							.play-button {
								width: 50px;
								height: 50px;
								border-radius: 50%;
								background: rgba(255, 255, 255, 0.9);
								display: flex;
								align-items: center;
								justify-content: center;
								transition: transform 0.2s;

								i {
									font-size: 24px;
									color: #409EFF;
								}
							}
						}

						.video-info {
							position: absolute;
							bottom: 0;
							left: 0;
							right: 0;
							padding: 8px 12px;
							background: linear-gradient(transparent, rgba(0, 0, 0, 0.6));

							.video-name {
								color: #fff;
								font-size: 12px;
								display: block;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
							}
						}

						&:hover {
							.video-play-overlay {
								background: rgba(0, 0, 0, 0.4);

								.play-button {
									transform: scale(1.1);
								}
							}
						}
					}
				}

				.chat-msg-file {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;
					cursor: pointer;
					margin-bottom: 2px;

					.chat-file-box {
						display: flex;
						flex-wrap: nowrap;
						align-items: center;
						min-height: 60px;
						box-shadow: var(--im-box-shadow-light);
						border-radius: 4px;
						padding: 10px 15px;

						.chat-file-info {
							flex: 1;
							height: 100%;
							text-align: left;
							font-size: 14px;
							margin-right: 10px;

							.chat-file-name {
								display: inline-block;
								min-width: 160px;
								max-width: 220px;
								font-size: 14px;
								margin-bottom: 4px;
								white-space: pre-wrap;
								word-break: break-all;
								color: #000000 !important;
							}

							.chat-file-size {
								font-size: var(--im-font-size-smaller);
								color: #999999;
							}
						}

						.chat-file-icon {
							display: flex;
							align-items: center;
							justify-content: center;
							width: 44px;
							height: 44px;
						}
					}

					.send-fail {
						color: #e60c0c;
						font-size: 30px;
						cursor: pointer;
						margin: 0 20px;
					}

				}

				.chat-msg-voice {
					font-size: 14px;
					cursor: pointer;

					audio {
						height: 45px;
						padding: 5px 0;
					}
				}

				.chat-action {
					display: flex;
					align-items: center;

					.iconfont {
						cursor: pointer;
						font-size: 22px;
						padding-right: 8px;
					}
				}

				.chat-msg-status {
					display: block;

					.chat-readed {
						font-size: 12px;
						color: var(--im-text-color-light);
					}

					.chat-unread {
						font-size: var(--im-font-size-smaller);
						color: var(--im-color-danger);
					}
				}

				.chat-receipt {
					font-size: var(--im-font-size-smaller);
					cursor: pointer;
					color: var(--im-text-color-light);

					.icon-ok {
						font-size: 20px;
						color: var(--im-color-sucess);
					}
				}

				.chat-at-user {
					padding: 2px 5px;
					border-radius: 3px;
					cursor: pointer;
				}
			}
		}


		&.chat-msg-mine {
			text-align: right;
			padding-left: 0;
			padding-right: 48px;

			.head-image {
				left: auto;
				right: 0;
			}

			.chat-msg-content {
				text-align: right;

				.chat-msg-top {
					flex-direction: row-reverse;

					span {
						margin-left: 12px;
						margin-right: 0;
					}
				}

				.chat-msg-bottom {
					max-width: min(70%, 500px);
					text-align: right;

					// 🔥 自己发送的消息中的横向布局容器
					.quote-and-status-row {
						display: flex !important;
						flex-direction: row-reverse !important;
						align-items: center; // 中线对齐
						gap: 12px;
						margin-top: 8px;
						flex-wrap: nowrap;
						justify-content: flex-start;

						// 箭头连接器样式（自己发送的消息中）
						.arrow-connector {
							font-size: 16px;
							color: #909399;
							font-weight: bold;
							flex-shrink: 0;
							padding: 0 4px;
						}

						// 🔥 引用消息显示样式（在横向布局中）
						.message-quoted-display {
							text-align: left;
							flex-shrink: 0;

							::v-deep .quoted-message-wrapper {
								padding: 0 !important;
								display: inline-block;

								.quoted-message-card {
									background: #f5f5f5;
									border-radius: 8px;
									max-width: 250px;
									border: 1px solid #e0e0e0;
								}
							}
						}

						// 🔥 智能体状态面板样式（在横向布局中）
						.message-agent-task-status {
							flex-shrink: 0;

							::v-deep .agent-task-status-wrapper {
								padding: 0 !important;
								text-align: left;
							}

							::v-deep .status-cards-container {
								justify-content: flex-start;
							}
						}
					}

					// 🔥 自己发送的消息右键菜单激活时的高亮效果（稍深的颜色）
					&.context-menu-active {
						.chat-msg-text,
						.chat-msg-image,
						.chat-msg-file {
							filter: brightness(0.92);
							transition: filter 0.15s ease;
						}
					}

					.chat-msg-text {
						margin-left: 10px;
						background-color: var(--im-color-primary-light-2);
						color: #fff;

						&:after {
							left: auto;
							right: -10px;
							border-top-color: var(--im-color-primary-light-2);
						}
						
						// 自己发送的Markdown消息样式
						::v-deep .unified-message-renderer {
							.message-markdown {
								.markdown-body {
									color: #fff !important;
									
									// 链接颜色
									a {
										color: #b3d9ff !important;
										
										&:hover {
											color: #d9ecff !important;
										}
									}
									
									// 代码块在深色背景下的样式
									.code-block-wrapper {
										.code-block-header {
											background: rgba(255, 255, 255, 0.1);
											color: #fff;
											
											.copy-button {
												background: rgba(255, 255, 255, 0.15);
												border-color: rgba(255, 255, 255, 0.3);
												color: #fff;
												
												&:hover {
													background: rgba(255, 255, 255, 0.2);
												}
											}
										}
										
										.code-block-content {
											pre {
												background: rgba(0, 0, 0, 0.2);
												color: #fff;
											}
										}
									}
									
									// 行内代码
									code:not(pre code) {
										background-color: rgba(255, 255, 255, 0.15);
										color: #fff;
									}
									
									// 表格
									.markdown-table {
										th {
											background-color: rgba(255, 255, 255, 0.1);
											color: #fff;
										}
										
										tr:nth-child(2n) {
											background-color: rgba(255, 255, 255, 0.05);
										}
										
										th, td {
											border-color: rgba(255, 255, 255, 0.2);
										}
									}
									
									// 引用
									blockquote {
										border-left-color: rgba(255, 255, 255, 0.5);
										color: rgba(255, 255, 255, 0.9);
									}
								}
							}
						}
					}

					.chat-msg-image {
						flex-direction: row-reverse;
					}

					.chat-msg-file {
						flex-direction: row-reverse;
					}

					.chat-action {
						flex-direction: row-reverse;

						.iconfont {
							transform: rotateY(180deg);
						}
					}
				}
			}
		}

	}
}

// 🔥 多选模式样式调整
.chat-msg-item.multi-select-mode {
	.chat-msg-normal {
		margin-left: 35px; /* 为选择框留出空间（选择框left: -30px + 边距5px） */
	}
}

@keyframes pulse {
	0%, 100% {
		opacity: 1;
		transform: scale(1);
	}
	50% {
		opacity: 0.4;
		transform: scale(0.85);
	}
}

// 全局VSCode环境样式覆盖
:global(.vscode-environment) {
	.chat-msg-text,
	.chat-msg-text * {
		user-select: text !important;
		-webkit-user-select: text !important;
		-moz-user-select: text !important;
		-ms-user-select: text !important;
		cursor: text !important;
		pointer-events: auto !important;
	}
}

// 🔧 文本选择优化样式
:global(.text-selectable) {
	user-select: text !important;
	-webkit-user-select: text !important;
	-moz-user-select: text !important;
	-ms-user-select: text !important;
	cursor: text !important;
	pointer-events: auto !important;
	
	// 覆盖可能阻止文本选择的样式
	&, & * {
		user-select: text !important;
		-webkit-user-select: text !important;
		-moz-user-select: text !important;
		-ms-user-select: text !important;
	}
}

// 智能体错误消息样式
.agent-error-message {
	background: linear-gradient(135deg, #fff5f5 0%, #fed7d7 100%);
	border: 1px solid #feb2b2;
	border-radius: 8px;
	padding: 12px 16px;
	margin: 4px 0;
	position: relative;
	
	// 错误消息图标
	&::before {
		content: "⚠️";
		position: absolute;
		top: 12px;
		left: 16px;
		font-size: 16px;
		width: 20px;
		height: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	// 为内容添加左边距以避免与图标重叠
	.unified-message-renderer,
	.markdown-renderer,
	.markdown-body {
		margin-left: 28px;
		color: #742a2a;
		
		// 确保链接在错误消息中仍然可见
		a {
			color: #e53e3e !important;
			text-decoration: underline;
		}
		
		// 代码块样式调整
		code {
			background: rgba(229, 62, 62, 0.1);
			color: #742a2a;
			border: 1px solid rgba(229, 62, 62, 0.2);
		}
		
		pre {
			background: rgba(229, 62, 62, 0.05);
			border: 1px solid rgba(229, 62, 62, 0.2);
		}
		
		// 强调文本样式
		strong, b {
			color: #742a2a;
			font-weight: 600;
		}
		
		// 列表样式
		ul, ol {
			color: #742a2a;
		}
		
		// 确保所有文本都是错误色调
		p {
			color: #742a2a;
		}
	}
	
	// 暗色主题支持
	.dark & {
		background: linear-gradient(135deg, #2d1b1b 0%, #4a2a2a 100%);
		border-color: #e53e3e;
		
		.unified-message-renderer,
		.markdown-renderer,
		.markdown-body {
			color: #fc8181;
			
			a {
				color: #f56565 !important;
			}
			
			code {
				background: rgba(245, 101, 101, 0.2);
				color: #fc8181;
			}
			
			pre {
				background: rgba(245, 101, 101, 0.1);
			}
			
			strong, b, p, ul, ol {
				color: #fc8181;
			}
		}
	}
}
</style>
